import { createContext, ReactNode, useContext, useState } from 'react'

type TeamEventPlanningInfoContextValue = {
  showPlanningInfo: boolean
  setShowPlanningInfo: (value: boolean) => void
}

const TeamEventPlanningInfoContext =
  createContext<TeamEventPlanningInfoContextValue | null>(null)

type TeamEventPlanningInfoProviderProps = {
  value: TeamEventPlanningInfoContextValue
  children: ReactNode
}

export const TeamEventPlanningInfoProvider = ({
  value,
  children,
}: TeamEventPlanningInfoProviderProps) => {
  return (
    <TeamEventPlanningInfoContext.Provider value={value}>
      {children}
    </TeamEventPlanningInfoContext.Provider>
  )
}

export const useTeamEventPlanningInfoState = (
  teamId: number,
  event?: wowaudit.Event,
) => {
  const planningInfoStorageKey = `teamEventPlanningInfo:${teamId}`
  const [showPlanningInfoState, setShowPlanningInfoState] = useState(() => {
    const storedValue = localStorage.getItem(planningInfoStorageKey)
    return storedValue === 'true'
  })

  const setShowPlanningInfo = (value: boolean) => {
    setShowPlanningInfoState(value)
    localStorage.setItem(planningInfoStorageKey, String(value))
  }

  const showPlanningInfo =
    showPlanningInfoState &&
    event?.activityType === 'raids' &&
    !(
      event?.raidsPlanningScope === 'single' && event?.primaryActivityId == null
    )

  return { showPlanningInfo, setShowPlanningInfo }
}

export const useTeamEventPlanningInfoContext = () => {
  const context = useContext(TeamEventPlanningInfoContext)
  if (!context) {
    throw new Error(
      'useTeamEventPlanningInfoContext must be used within provider',
    )
  }
  return context
}
